<template>
  <el-dialog
    class="edit-dialog"
    title="选择图书"
    :visible.sync="currentVisible"
    width="880px"
    top="6vh"
    :close-on-click-modal="false"
    append-to-body
  >
    <div>
      <search />

      <el-table
        ref="table"
        :data="state.list.items"
        size="small"
        @selection-change="onSelectChange"
        v-loading="state.list.loading"
        height="530"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="book-detail-expand">
              <div class="book-detail-expand__left">
                <img class="cover-img" :src="props.row.image" alt="" />
              </div>
              <div class="book-detail-expand__body">
                <p><span>ISBN:</span> {{ props.row.isbn_13 }}</p>
                <p>
                  <span>图书名称:</span> {{ props.row.title }}
                  {{ props.row.subtitle }}
                </p>
                <p><span>作者:</span> {{ props.row.author | join }}</p>
                <p><span>出版社:</span> {{ props.row.publisher }}</p>
                <p><span>出版时间:</span> {{ props.row.pub_date | date }}</p>
                <p>
                  <span>数据更新时间:</span> {{ props.row.updated_at | date }}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column type="selection" width="55" />

        <el-table-column label="图书名称">
          <template slot-scope="scope">
            <div class="title" style="font-size: 14px">
              {{ scope.row.title }}
            </div>
            <small class="desc" style="color: #999">{{
              scope.row.author | join
            }}</small>
          </template>
        </el-table-column>

        <el-table-column label="分类" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.tags | join('name') }}
          </template>
        </el-table-column>

        <el-table-column
          prop="publisher"
          label="出版社"
          width="160"
          show-overflow-tooltip
        />
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="state.list.index"
        :total="state.list.total"
        :page-size="state.list.size"
        layout="total, prev, pager, next"
        background
      />
    </div>

    <el-row slot="footer" class="dialog-footer">
      <el-col :span="12" class="selectNum">
        <span
          >已选中&nbsp;<span class="blue">{{ selectedItems.length }}</span
          >&nbsp;本</span
        >
      </el-col>
      <el-col :span="12" class="btn">
        <el-button @click="cancel"> 取消 </el-button>
        <el-button type="primary" @click="confirm"> 确定 </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script lang="ts">
import _ from 'lodash'
import { MessageService } from '../../admin-shared-modules/utils/message.service'
import Search from './book-selector-search.component.vue'
import store from './book-selector.store'

export default {
  components: {
    Search
  },

  props: {
    visible: { type: Boolean }
  },
  data() {
    return {
      state: store.state,
      currentVisible: false,

      selectedItems: []
    }
  },
  watch: {
    visible(v) {
      this.currentVisible = v
    },
    currentVisible(v) {
      if (v) {
        store.fetch(true)
      }
      this.$emit('update:visible', v)
    }
  },

  methods: {
    async handleCurrentChange(index) {
      this.state.list.index = index
      await store.fetch()
      this.setTableCurrentSelection()
    },

    onSelectChange(items) {
      const unSelectedItems = _.differenceBy(this.state.list.items, items, 'id')
      this.selectedItems = _.chain(this.selectedItems)
        .unionBy(items, 'id')
        .differenceBy(unSelectedItems, 'id')
        .value()
    },
    setTableCurrentSelection() {
      const selectedRow = _.intersectionBy(
        this.state.list.items,
        this.selectedItems,
        'id'
      )
      _.forEach(selectedRow, row =>
        this.$refs.table.toggleRowSelection(row, true)
      )
    },

    async cancel() {
      this.currentVisible = false
    },
    async confirm() {
      if (!this.selectedItems.length) {
        MessageService.open({ message: '请选择图书', type: 'warning' })
        return
      }
      this.$emit(
        'confirm',
        _.cloneDeep(this.selectedItems),
        _.map(this.selectedItems, 'id')
      )
      this.selectedItems = []
      this.currentVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.book-detail-expand {
  display: flex;
  &__left {
    img {
      display: block;
      max-width: 140px;
      height: auto;
    }
  }
  &__body {
    flex: 1;
    margin-left: 1em;
  }

  p {
    margin: 0;
  }
}
.dialog-footer {
  .selectNum {
    text-align: left !important;
    line-height: 40px;
    color: #000;
    font-size: 16px;
    font-weight: 600;
    .blue {
      color: #409eff;
    }
  }
  .btn {
    text-align: right;
  }
}
</style>
